export default "__VITE_ASSET__D_mVL6ya__"